module.exports = __webpack_public_path__ + "static/media/97dd465e.jpg";